import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';

// Rejects under live reload on a binary built before the plugin was added.
const ignore = () => {};

/**
 * The plugin hides WKWebView's form accessory bar on load, and has no config key to keep it.
 * Its Done button is the only way to dismiss the decimal and number pads, which have no return key.
 */
export function installKeyboardAccessoryBar(): void {
	if (Capacitor.getPlatform() === 'ios') Keyboard.setAccessoryBarVisible({ isVisible: true }).catch(ignore);
}
